import React, {
  Fragment,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { WizardContext } from "../../index";
import { syncCartWithFilteredBoltOns } from "../../functions/coworking";

export default function BoltOns({ inCart, isDisplayCart }) {
  const { homeLocation, locationType, cart, setCart, startDate } =
    useContext(WizardContext);

  const boltOns = useMemo(() => {
    // const currentLocation =
    //   locationType == "single"
    //     ? homeLocation
    //     : locationData.find(
    //         (loc) => loc.page_template_slug == "single-our_locations.php"
    //       )?.id;

    const currentLocation = homeLocation;
    const location = locationData.find((loc) => loc.id == currentLocation);

    if (!location) return [];

    try {
      const parsed = JSON.parse(location.coworking_extras_bolt_ons);
      return Object.entries(parsed).map(([key, value]) => {
        const slug = key.replace("_group", "");
        return {
          slug,
          key,
          ...value,
        };
      });
    } catch (e) {
      return [];
    }
  }, [locationData, homeLocation, locationType]);

  const filteredBoltOns = boltOns.filter(
    (item) => item.chargeable_price_per_unit > 0
  );

  useEffect(() => {
    if (filteredBoltOns?.length) {
      syncCartWithFilteredBoltOns(filteredBoltOns, cart, setCart);
    } else {
      if (Object.keys(cart?.coworking_extras_bolt_ons || {}).length > 0) {
        setCart((prev) => ({ ...prev, coworking_extras_bolt_ons: {} }));
      }
    }
  }, [filteredBoltOns, homeLocation, locationType]);

  const [openItemId, setOpenItemId] = useState(null);

  const deleteItem = (id) => {
    setOpenItemId(null);
  };

  // useEffect(() => {
  //   const handleClickOutside = () => setOpenItemId(null);
  //   document.addEventListener("click", handleClickOutside);
  //   return () => document.removeEventListener("click", handleClickOutside);
  // }, []);

  return (
    <>
      {filteredBoltOns.length > 0 ? (
        filteredBoltOns.map((item) => (
          <Fragment key={item.slug}>
            {item.chargeable_price_per_unit > 0 &&
              ((inCart &&
                cart.coworking_extras_bolt_ons?.[item.slug]?.qty > 0) ||
                !inCart) && (
                <div
                  className={`list-container${
                    item.full_width ? " fullWidth" : ""
                  }${item.highlighted_card ? " highlightedCard" : ""}`}
                >
                  <SwipeItem
                    key={item.id}
                    item={item}
                    onDelete={deleteItem}
                    isOpen={openItemId === item.id}
                    setOpenItemId={setOpenItemId}
                    cart={cart}
                    setCart={setCart}
                    inCart={inCart}
                    isDisplayCart={isDisplayCart}
                    startDate={startDate}
                  />
                </div>
              )}

            {item.chargeable_price_per_unit > 0 ? (
              <></>
            ) : (
              <>{cart.coworking_extras_bolt_ons?.[item.slug]}</>
            )}
          </Fragment>
        ))
      ) : (
        <>
          {!inCart && (
            <div className="noItems">There are no Extras available.</div>
          )}
        </>
      )}

      {inCart &&
        (!cart?.coworking_extras_bolt_ons ||
          Object.entries(cart.coworking_extras_bolt_ons).length === 0) && (
          <div className="noItems">No extras added</div>
        )}
    </>
  );
}

const SwipeItem = ({
  item,
  onDelete,
  isOpen,
  setOpenItemId,
  cart,
  setCart,
  inCart,
  isDisplayCart,
  startDate,
}) => {
  const updateQty = (
    charge_full_price,
    name,
    hs_field_id,
    slug,
    price,
    qty
  ) => {
    setCart((prev) => {
      const newCart = { ...prev };
      const group = { ...newCart.coworking_extras_bolt_ons };
      qty = parseInt(qty);
      if (qty > 0) {
        group[slug] = { name, hs_field_id, price, qty, charge_full_price };
      } else {
        delete group[slug];
      }

      newCart.coworking_extras_bolt_ons = group;
      return newCart;
    });
  };

  const [xOffset, setXOffset] = useState(0);
  const touchStartX = useRef(0);
  const wasDragging = useRef(false);
  const wrapperRef = useRef();

  const handleTouchStart = (e) => {
    if (inCart && cart.coworking_extras_bolt_ons?.[item.slug]?.qty > 0) {
      touchStartX.current = e.touches[0].clientX;
      wasDragging.current = false;
    }
  };

  const handleTouchMove = (e) => {
    if (inCart && cart.coworking_extras_bolt_ons?.[item.slug]?.qty > 0) {
      const deltaX = e.touches[0].clientX - touchStartX.current;

      if (deltaX < 0) {
        setXOffset(Math.max(deltaX, -60));
      } else if (deltaX > 0 && isOpen) {
        setXOffset(Math.min(deltaX - 60, 0));
      }
    }
  };

  const handleTouchEnd = () => {
    if (inCart && cart.coworking_extras_bolt_ons?.[item.slug]?.qty > 0) {
      if (xOffset <= -60) {
        setXOffset(-60);
        setOpenItemId(item.id);
      } else if (isOpen && xOffset > -30) {
        setXOffset(0);
        setOpenItemId(null);
      } else {
        setXOffset(0);
      }
    }
  };

  const handleClick = (e) => {
    e.stopPropagation();
  };

  // useEffect(() => {
  //   if (!isOpen) setXOffset(0);
  // }, [isOpen]);

  const endOfCurrentMonth = new Date(
    startDate.getFullYear(),
    startDate.getMonth() + 1,
    0
  );
  var endDate = endOfCurrentMonth.getDate();
  var midMonthExtraPrice = item.chargeable_price_per_unit;
  // if (startDate.getDate() != 1 && !item.charge_full_price) {
  //   midMonthExtraPrice =
  //     (item.chargeable_price_per_unit / endDate) *
  //     (endDate + 1 - startDate.getDate());
  // }

  return (
    <div className="swipe-wrapper" ref={wrapperRef}>
      {inCart && cart.coworking_extras_bolt_ons?.[item.slug]?.qty > 0 && (
        <div
          className="deleteBoltOns"
          onClick={() => {
            onDelete(item.id);
            setXOffset(0);
            updateQty(
              item.charge_full_price,
              item.name,
              item.hs_field_id,
              item.slug,
              item.chargeable_price_per_unit,
              0
            );
          }}
        ></div>
      )}
      <div
        className="swipeable-item"
        style={{ transform: `translateX(${xOffset}px)` }}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
        onClick={handleClick}
      >
        <div className="itemBlock">
          <div>
            <div className="innerBlock">
              {isDisplayCart ? (
                <div>
                  <div className="field-label">
                    <span dangerouslySetInnerHTML={{ __html: item.name }} /> x{" "}
                    {cart.coworking_extras_bolt_ons?.[item.slug]?.qty}
                  </div>
                  <div className="field-container">
                    £
                    {(
                      Number(midMonthExtraPrice) *
                      Number(cart.coworking_extras_bolt_ons?.[item.slug]?.qty)
                    ).toFixed(2)}
                  </div>
                </div>
              ) : (
                <>
                  <div>
                    {item.icon && (
                      <div className="iconHolder">
                        <img className="icon" src={item.icon} alt={item.name} />
                      </div>
                    )}
                    <div className="textHolder">
                      <strong dangerouslySetInnerHTML={{ __html: item.name }} />
                      <span className="priceSummary">{item.price_summary}</span>
                      <button
                        onClick={() =>
                          updateQty(
                            item.charge_full_price,
                            item.name,
                            item.hs_field_id,
                            item.slug,
                            item.chargeable_price_per_unit,
                            0
                          )
                        }
                        className="deleteBoltOns"
                      >
                        X
                      </button>
                    </div>
                  </div>
                  <div className="btnHolder">
                    <div
                      className="price"
                      dangerouslySetInnerHTML={{ __html: item.from_price_text }}
                    />
                    <div className="controlbtn">
                      <button
                        className="minusBtn"
                        onClick={() =>
                          updateQty(
                            item.charge_full_price,
                            item.name,
                            item.hs_field_id,
                            item.slug,
                            item.chargeable_price_per_unit,
                            (cart.coworking_extras_bolt_ons?.[item.slug]?.qty ||
                              0) - 1
                          )
                        }
                      >
                        -
                      </button>
                      <input
                        type="text"
                        onChange={(e) =>
                          updateQty(
                            item.charge_full_price,
                            item.name,
                            item.hs_field_id,
                            item.slug,
                            item.chargeable_price_per_unit,
                            e.target.value
                          )
                        }
                        value={
                          cart.coworking_extras_bolt_ons?.[item.slug]?.qty || 0
                        }
                      />
                      <button
                        className="plusBtn"
                        onClick={() =>
                          updateQty(
                            item.charge_full_price,
                            item.name,
                            item.hs_field_id,
                            item.slug,
                            item.chargeable_price_per_unit,
                            (cart.coworking_extras_bolt_ons?.[item.slug]?.qty ||
                              0) + 1
                          )
                        }
                      >
                        +
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
